import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { defaultAxiosRequestConfig } from "~/api/apiMethods";
import { AttachmentsDetailsError, FileTypeEnum, QuestionnaireTypeEnum } from "~/typings/types";
import { clientApi } from "~/utils";

const configRequest = {
  ...defaultAxiosRequestConfig,
  headers: {
    "Content-Type": "multipart/form-data"
  }
};

type Props = {
  logoFiles: File[];
  setLogoError: Dispatch<SetStateAction<AttachmentsDetailsError>>;
  setIsFirstLoadingFile: Dispatch<boolean>;
  urlHelperFile: string;
  fileType?: FileTypeEnum;
  questionnaireType?: QuestionnaireTypeEnum;
  questionnaireUid?: string;
  setLogoFiles?: Dispatch<SetStateAction<File[]>>;
};

/** Используется если загрузить нужно только 1 файл */
export const useUploadLogoFile = ({
  logoFiles,
  setLogoError,
  setIsFirstLoadingFile,
  urlHelperFile,
  fileType,
  questionnaireType,
  questionnaireUid,
  setLogoFiles
}: Props) => {
  const [isMounted, setIsMounted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [filesId, setFilesId] = useState<number[]>([]);

  useEffect(() => {
    if (isMounted) {
      try {
        if (!logoFiles.length || !(logoFiles.length && filesId.length < logoFiles.length)) {
          return;
        }
        setIsLoading(true);
        const failedFile = logoFiles[logoFiles.length - 1];
        const removeFailedFile = () => {
          setLogoFiles?.(prev => prev.filter(f => f !== failedFile));
        };
        let formData = new FormData();
        logoFiles.forEach(file => formData.append("file", file));
        if (fileType) {
          formData.append("file_type", fileType);
        }
        if (questionnaireType) {
          formData.append("questionnaire_type", questionnaireType);
        }
        if (questionnaireUid) {
          formData.append("questionnaire_uid", questionnaireUid);
        }

        clientApi
          .post(urlHelperFile, formData, configRequest)
          .then(response => {
            const data = response?.data;

            if (data?.success === 0 || !data?.data?.file_id) {
              setLogoError({
                has: 1,
                message: data?.errors?.[0]?.message || data?.error?.[0]?.message || "Не удалось загрузить файл"
              });
              removeFailedFile();
              return;
            }

            const fileId = data.data.file_id;
            setFilesId(prev => [...prev, fileId]);
            setIsFirstLoadingFile(true);
          })
          .catch(error => {
            setLogoError({
              has: 1,
              message: error.response?.data?.error?.[0].message
            });
            removeFailedFile();
          })
          .finally(() => {
            setIsLoading(false);
          });
      } catch (error) {
      }
    } else {
      setIsMounted(true);
    }
  }, [logoFiles]);

  return { filesId, setFilesId, isLoading };
};
